import { FileTwoTone } from '@ant-design/icons'
import { Button, List } from 'antd'
import { useSharePointUploaderContext } from '../../SharePointUploaderContext'
import { SharePointResourceListProps } from './types'
import CIMSLink from '../../../CIMSLink'

const SharePointResourceList: React.FC<SharePointResourceListProps> = ({
  preventDelete = false,
  exclude,
}) => {
  const { remove, sharePointResource, loading } = useSharePointUploaderContext()
  if (!sharePointResource?.sharePointResources?.length) return null
  return (
    <List
      size="small"
      loading={loading}
      header="Previously Uploaded Files"
      itemLayout="horizontal"
      dataSource={sharePointResource?.sharePointResources ?? []}
      renderItem={(sharePointResource) => {
        if (exclude?.(sharePointResource)) return null
        const { id, webUrl, name } = sharePointResource
        const label = name ?? id
        return (
          <List.Item>
            <List.Item.Meta
              avatar={<FileTwoTone />}
              title={
                <CIMSLink
                  external
                  href={webUrl}
                  tooltip={!webUrl ? `No webUrl found for ${label}` : undefined}
                >
                  {label}
                </CIMSLink>
              }
            />
            <Button
              type="link"
              disabled={preventDelete}
              onClick={() => remove(id)}
            >
              Delete
            </Button>
          </List.Item>
        )
      }}
    />
  )
}

export default SharePointResourceList
